import { Module, ActionContext } from 'vuex'
import { RootState, MemberActivityFilters } from '../store'

export interface MemberActivityState {
  memberActivityFilters: MemberActivityFilters
}

type activitiesActionContext = ActionContext<MemberActivityState, RootState>

export default class MemberActivitiesModule implements Module<MemberActivityState, RootState> {
  state: MemberActivityState

  actions: {
    filterActivities: (context: activitiesActionContext, by: MemberActivityFilters) => void
  }

  mutations: {
    setFilters: (state: MemberActivityState, filters: MemberActivityFilters) => void
  }

  constructor () {
    this.state = {
      memberActivityFilters: {
        type:  '',
        status:  new Set(['completed', 'planned'])
      }
    }

    this.mutations = {
      setFilters: (state, filters) => {
        state.memberActivityFilters = { ...state.memberActivityFilters, ...filters }
      }
    }

    this.actions = {
      filterActivities: (context, by) => {
        context.commit('setFilters', by)
      }
    }
  }

}
